import { Component } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { VoiceTestResult } from '../../../../shared/models/voice-testing.model';
import { VoiceTestingService } from '../../../../shared/services/voice-testing.service';

@Component({
  standalone: false,
  selector: 'app-sip-results-table-actions',
  templateUrl: './sip-results-table-actions.component.html',
  styleUrls: ['./sip-results-table-actions.component.scss'],
})
export class SipResultsTableActionsComponent {
  constructor(private service: VoiceTestingService) {}

  currentRow: VoiceTestResult;

  agInit(params: ICellRendererParams): void {
    this.currentRow = params.data;
  }

  refresh(params: ICellRendererParams) {
    return true;
  }

  onClick(clickedItem: string) {
    this.service.announceAction({ name: clickedItem, row: this.currentRow, column: 'action' });
  }
}
